<ion-list>
  <ion-list-header>
    <span translate>SagaMobile.UA.VehicleSettings.Label</span>
  </ion-list-header>
  <ion-item>
    <ion-toggle [(ngModel)]="options.extended">{{'SagaMobile.UA.VehicleSettings.Extanded' | translate}}</ion-toggle>
  </ion-item>
</ion-list>
